import { api, badge, flashMessage, formatter, modal, translate } from './util';
import { searchFormHelper } from './search-form';
import { productHelper } from './product';

/**
 * Shared features of product groups.
 */
var productGroupHelper = (function ($) {
	/**
	 * Redirect to the product group details.
	 *
	 * @param {object} event Event data.
	 * @param {{
	 *     productGroup: {
	 *         id: string,
	 *         name: string,
	 *         notification: {
	 *             settings: {
	 *                 outagesFrequency: string,
	 *                 scauDiffFrequency: string,
	 *                 incrementDecrementFrequency: string,
	 *                 safetyStockRequestFrequency: string,
	 *                 dataviewFrequency: string
	 *             }
	 *         },
	 *         productsCount: int,
	 *         ignoredProductGroup: [{
	 *             id: string,
	 *             name: string
	 *         }]
	 *     }
	 * }} response Data returned from the server.
	 */
	var redirectToProductGroupDetail = function (event, response) {
		location.href = '/product-groups/' + response.productGroup.id;
	};

	/**
	 * Handle successful save of notification settings.
	 *
	 * @param {object} event Event data.
	 * @param {string} groupId Id of updated product group.
	 * @param {{
	 *     notificationSettings: {
	 *         outagesFrequency: string,
	 *         scauDiffFrequency: string,
	 *         incrementDecrementFrequency: string,
	 *         safetyStockRequestFrequency: string,
	 *         dataviewFrequency: string
	 *     }
	 * }} response Data returned from the server.
	 */
	var notificationSettingsSaved = function (event, groupId, response) {
		updateNotificationSettings(
			$('.product-group[data-group-id=' + groupId + ']'),
			response.notificationSettings.outagesFrequency,
			response.notificationSettings.scauDiffFrequency,
			response.notificationSettings.incrementDecrementFrequency,
			response.notificationSettings.safetyStockRequestFrequency,
			response.notificationSettings.dataviewFrequency
		);
		flashMessage.show('success', $('.notification-settings-modal').data('success-message'));
	};

	/**
	 * Update notification settings.
	 *
	 * @param {object} productGroupContainer Container of the product group.
	 * @param {string} outagesFrequency Frequency of outages notification emails.
	 * @param {string} scauDiffFrequency Frequency of SCAU diff (monthly / disabled).
	 * @param {string} incrementDecrementFrequency Frequency of increment / decrement of LP in list (monthly / disabled).
	 * @param {string} safetyStockRequestFrequency Frequency of safety stock requests of LP in list (daily / disabled).
	 * @param {string} dataviewFrequency Frequency of dataview report in list (monthly / disabled).
	 */
	var updateNotificationSettings = function (
		productGroupContainer,
		outagesFrequency,
		scauDiffFrequency,
		incrementDecrementFrequency,
		safetyStockRequestFrequency,
		dataviewFrequency
	) {
		productGroupContainer.data('outages-frequency', outagesFrequency);
		productGroupContainer.data('scau-diff-frequency', scauDiffFrequency);
		productGroupContainer.data('increment-decrement-frequency', incrementDecrementFrequency);
		productGroupContainer.data('safety-stock-request-frequency', safetyStockRequestFrequency);
		productGroupContainer.data('dataview-frequency', dataviewFrequency);
		productGroupContainer
			.find('.btn-notification')
			.toggleClass(
				'btn-notification-act',
				outagesFrequency !== 'disabled' ||
					scauDiffFrequency !== 'disabled' ||
					incrementDecrementFrequency !== 'disabled' ||
					safetyStockRequestFrequency !== 'disabled' ||
					dataviewFrequency !== 'disabled'
			);
	};

	/**
	 * Handle successful rename of product group.
	 *
	 * @param {object} event Event data.
	 * @param {{
	 *     productGroup: {
	 *         id: string,
	 *         name: string,
	 *         notification: {
	 *             settings: {
	 *                 outagesFrequency: string,
	 *                 scauDiffFrequency: string,
	 *                 incrementDecrementFrequency: string,
	 *                 safetyStockRequestFrequency: string,
	 *                 dataviewFrequency: string
	 *             }
	 *         },
	 *         productsCount: int,
	 *         ignoredProductGroup: [{
	 *             id: string,
	 *             name: string
	 *         }]
	 *     }
	 * }} response Data returned from the server.
	 */
	var updateProductGroupName = function (event, response) {
		$('.product-group[data-group-id=' + response.productGroup.id + '] .product-group-name')
			.attr('title', response.productGroup.name)
			.text(response.productGroup.name);

		let ignoredProductGroup = response.productGroup.ignoredProductGroup;
		if (ignoredProductGroup != null) {
			$('.product-group[data-group-id=' + response.productGroup.id + '] .product-group-ignored').show();
			$('.product-group[data-group-id=' + response.productGroup.id + '] .product-group-ignored-name')
				.attr('title', ignoredProductGroup.name)
				.text(ignoredProductGroup.name);
		} else {
			$('.product-group[data-group-id=' + response.productGroup.id + '] .product-group-ignored').hide();
			$('.product-group[data-group-id=' + response.productGroup.id + '] .product-group-ignored-name')
				.attr('title', '')
				.text('');
		}

		modal.hide();
	};

	var createSaveFiltersApiRequest = function (groupId) {
		var values = searchFormHelper.getSearchFormValues();
		var tfValues = searchFormHelper.getTFValues();
		var operator = searchFormHelper.getOperatorValue();
		var view = searchFormHelper.getViewValue();
		var withProductBrothers = searchFormHelper.isWithProductBrothers();
		var filters = [];

		for (var i = 0; i < values.length; i++) {
			filters.push({
				type: getFilterType(values[i].name),
				value: values[i].value,
			});
		}

		for (var j = 0; j < tfValues.length; j++) {
			filters.push({
				type: tfValues[j].name,
				value: tfValues[j].value,
			});
		}

		if (filters.length === 0) {
			filters.push({
				type: 'all',
				value: '',
			});
		}

		return api.put(
			'/users/' + encodeURIComponent(api.getUserId()) + '/product-groups/' + encodeURIComponent(groupId) + '/filters',
			{
				productGroupFilters: filters,
				operator: operator,
				view: view,
				withProductBrothers: withProductBrothers,
			}
		);
	};

	var getFilterType = function (name) {
		var type = name
			.replace('filter-', '')
			.split('-')
			.map(function (part) {
				return part.charAt(0).toUpperCase() + part.substring(1);
			})
			.join('');

		return type.charAt(0).toLowerCase() + type.substring(1);
	};

	return {
		redirectToProductGroupDetail: redirectToProductGroupDetail,
		notificationSettingsSaved: notificationSettingsSaved,
		updateNotificationSettings: updateNotificationSettings,
		updateProductGroupName: updateProductGroupName,
		createSaveFiltersApiRequest: createSaveFiltersApiRequest,
	};
})(jQuery);

/**
 * Features of product group list.
 */
var productGroupList = (function ($) {
	var root;

	var init = function () {
		root = $('.product-group-list');

		if (root.length === 0) {
			return;
		}

		root.find('.search-form-container').searchForm();
		root.find('.btn-create-product-group').createProductGroupModal('.create-product-group-modal');
		root.find('.content-list .btn-load-more').loadMore(getProductGroupsApiUrl(), createContainers);

		attachProductGroupContainerHandlers(root.find('.product-groups .product-group'));

		$(document).on('productGroup.created', productGroupHelper.redirectToProductGroupDetail);
		$(document).on('productGroup.notificationSettingsSaved', productGroupHelper.notificationSettingsSaved);
		$(document).on('productGroup.renamed', productGroupHelper.updateProductGroupName);
		$(document).on('productGroup.removed', removeProductGroupContainer);
	};

	var attachProductGroupContainerHandlers = function (productGroupContainers) {
		productGroupContainers.find('.btn-options').popover('.popover');
		productGroupContainers.find('.btn-notification').productNotificationSettingsModal('.notification-settings-modal');
		productGroupContainers.find('.popover .btn-rename').renameProductGroupModal('.rename-product-group-modal');
		productGroupContainers.find('.popover .btn-remove').removeProductGroupModal('.remove-product-group-modal');
	};

	var getProductGroupsApiUrl = function () {
		return '/users/' + encodeURIComponent(api.getUserId()) + '/product-groups';
	};

	/**
	 * Load next product group by AJAX.
	 *
	 * @param {object} event Event data.
	 * @param {string} groupId Id of removed product group.
	 */
	var removeProductGroupContainer = function (event, groupId) {
		root.find('.product-group[data-group-id=' + groupId + ']').remove();
		modal.hide();
		flashMessage.show('success', root.find('.remove-product-group-modal').data('success-message'));

		if (!root.find('.content-list .btn-load-more').is(':visible')) {
			return;
		}

		api
			.get(getProductGroupsApiUrl() + '?page=' + (root.find('.product-group').length + 1) + '&perPage=1')
			.done(createContainers);
	};

	/**
	 * Create product group containers from data.
	 *
	 * @param {{
	 *     items: {
	 *         id: string,
	 *         name: string,
	 *         notification: {
	 *             settings: {
	 *                 outagesFrequency: string,
	 *                 scauDiffFrequency: string,
	 *                 incrementDecrementFrequency: string,
	 *                 safetyStockRequestFrequency: string,
	 *                 dataviewFrequency: string
	 *             }
	 *         },
	 *         productsCount: int,
	 *         ignoredProductGroup: [{
	 *             id: string,
	 *             name: string
	 *         }]
	 *     }[],
	 *     pagination:{
	 *         total:int,
	 *         perPage:int,
	 *         currentPage:int,
	 *         totalPages:int
	 *     }
	 * }} response Data returned from the server.
	 */
	var createContainers = function (response) {
		root.find('.content-list .btn-load-more').toggle(response.pagination.currentPage < response.pagination.totalPages);

		for (var i = 0; i < response.items.length; i++) {
			createContainer(response.items[i]);
		}
	};

	/**
	 * Create product group container.
	 *
	 * @param {{
	 *     id: string,
	 *     name: string,
	 *     notification: {
	 *         settings: {
	 *             outagesFrequency: string,
	 *             scauDiffFrequency: string,
	 *             incrementDecrementFrequency: string,
	 *             safetyStockRequestFrequency: string,
	 *             dataviewFrequency: string
	 *         }
	 *     },
	 *     productsCount: int,
	 *     ignoredProductGroup: [{
	 *         id: string,
	 *         name: string
	 *     }]
	 * }} productGroup Definition of the product group.
	 */
	var createContainer = function (productGroup) {
		var productGroupsContainer = root.find('.product-groups');
		var productGroupContainer = productGroupsContainer.find('.product-group:first').clone();
		var productsCount = productGroup.productsCount;
		var productsCountText = translate.selectForm(productGroupsContainer.data(), productsCount);

		productGroupContainer.attr('data-group-id', productGroup.id);
		productGroupContainer
			.find('.product-group-name')
			.attr('href', '/product-groups/' + productGroup.id)
			.attr('title', productGroup.name)
			.text(productGroup.name);
		productGroupContainer
			.find('.js-product-dashboard-export')
			.attr(
				'href',
				'/users/' + encodeURIComponent(api.getUserId()) + '/product/dashboard/product-group/' + productGroup.id
			);
		productGroupContainer.find('.js-dataview-export').attr('data-product-group-id', productGroup.id);
		var additionalContainer = productGroupContainer.find('p');
		additionalContainer.find('span').text(formatter.formatNumber(productsCount) + ' ' + productsCountText);
		additionalContainer.find('a').attr('href', '/product-groups/' + productGroup.id + '/dis');

		productGroupHelper.updateNotificationSettings(
			productGroupContainer,
			productGroup.notification.settings.outagesFrequency,
			productGroup.notification.settings.scauDiffFrequency,
			productGroup.notification.settings.incrementDecrementFrequency,
			productGroup.notification.settings.safetyStockRequestFrequency,
			productGroup.notification.settings.dataviewFrequency
		);
		attachProductGroupContainerHandlers(productGroupContainer);

		productGroupsContainer.append(productGroupContainer);
	};

	return {
		init: init,
	};
})(jQuery);

/**
 * Features of product group detail.
 */
var productGroupDetail = (function ($) {
	var root;

	var init = function () {
		root = $('.product-group-detail');

		if (root.length === 0) {
			return;
		}

		root.find('.btn-options').popover('.popover');
		root.find('.btn-notification').productNotificationSettingsModal('.notification-settings-modal');
		root.find('.popover .btn-rename').renameProductGroupModal('.rename-product-group-modal');
		root.find('.popover .btn-remove').removeProductGroupModal('.remove-product-group-modal');
		root.find('.btn-save').apiButton(createSaveFiltersApiRequestWithSpinner);
		root.find('.btn-cancel').click(cancelChangeFilters);
		root.find('.btn-edit').click(openSearchForm);
		root.find('.product-table .table tbody tr').clickableRow('btn-detail');
		root
			.find('.product-table .btn-load-more')
			.loadMore(getProductGroupUrl() + '/products', productHelper.createProductTableRows);

		$(document).on('productGroup.notificationSettingsSaved', productGroupHelper.notificationSettingsSaved);
		$(document).on('productGroup.renamed', productGroupHelper.updateProductGroupName);
		$(document).on('productGroup.removed', redirectToProductGroupList);
	};

	var getProductGroupId = function () {
		return root.find('.product-group').data('group-id');
	};

	var getProductGroupUrl = function () {
		return (
			'/users/' + encodeURIComponent(api.getUserId()) + '/product-groups/' + encodeURIComponent(getProductGroupId())
		);
	};

	/**
	 * Redirect to the product group list.
	 */
	var redirectToProductGroupList = function () {
		location.href = '/product-groups';
	};

	var openSearchForm = function () {
		root.find('.product-group-edit-close').hide();
		root.find('.product-group-edit-open').show();
		cloneSearchFormContainer();
	};

	var cloneSearchFormContainer = function () {
		// Clone the search form, so it is possible to cancel all changes with cancel button.
		// There is a problem with copying state of selects, so 'selected' attributed needs to be set.
		var originalSearchFormContainer = root.find('.search-form-container');
		originalSearchFormContainer.find('select').each(setOptionsSelectedAttribute);

		var searchFormContainer = originalSearchFormContainer.clone(true);
		root.find('.product-group-search-form').prepend(searchFormContainer);

		// Initialize the search form.
		searchFormContainer.show();
		searchFormContainer.searchForm();
	};

	var setOptionsSelectedAttribute = function () {
		$(this)
			.find('option')
			.each(function () {
				$(this).attr('selected', $(this).is(':selected'));
			});
	};

	var cancelChangeFilters = function () {
		// Remove the search form which has been cloned in the openSearchForm function and this way
		// effectively discard all changes in product group filters which should not be saved.
		var containers = root.find('.product-group-search-form .search-form-container');

		if (containers.length > 1) {
			containers.first().remove();
		}

		// Close the search form.
		closeSearchForm();
	};

	var closeSearchForm = function () {
		hideSearchFormContainer();
		root.find('.product-group-edit-open').hide();
		root.find('.product-group-edit-close').show();
	};

	var hideSearchFormContainer = function () {
		var searchFormContainer = root.find('.product-group-edit-open .search-form-container');
		searchFormContainer.searchForm('destroy');
		searchFormContainer.hide();
		badge.hide(root.find('.buttons .badge'));
	};

	var loadProducts = function (url) {
		var productTableContainer = root.find('.product-table');
		var productTable = productTableContainer.find('.table');
		var loadingContainer = productTableContainer.find('.loading-container');

		productTable.hide();
		productTableContainer.find('.load-more').hide();
		productTableContainer.find('.no-results-container').hide();
		loadingContainer.show();

		api.get(url).done(function (response) {
			loadingContainer.hide();

			// Update the product table.
			productTable.find('tbody tr').remove();
			productHelper.createProductTableRows(response);
			productTable.find('tbody tr').clickableRow('btn-detail');

			// Update products count.
			root.find('.product-group-products-count').text(formatter.formatNumber(response.pagination.total));

			// Initialize the load more button.
			var loadMoreButton = productTableContainer.find('.btn-load-more');
			loadMoreButton.unbind('click');
			loadMoreButton.loadMore(url, productHelper.createProductTableRows);
		});
	};

	var createSaveFiltersApiRequestWithSpinner = function () {
		root.find('.btn-cancel').prop('disabled', true);
		badge.show(root.find('.buttons .badge'), 'icon-spinner', 'spinner-text');

		return $.when($(document).delay(500)).done(createSaveFiltersApiRequest);
	};

	var createSaveFiltersApiRequest = function () {
		return productGroupHelper.createSaveFiltersApiRequest(getProductGroupId()).done(function () {
			if ($('.product-table').length === 0) {
				location.reload();
				return;
			}

			root.find('.btn-cancel').prop('disabled', false);

			// Remove the old (not cloned) search form and thus preserve the changes of the
			// product group filters.
			var containers = root.find('.product-group-search-form .search-form-container');

			if (containers.length > 1) {
				containers.last().remove();
			}

			hideSearchFormContainer();
			cloneSearchFormContainer();
			loadProducts(getProductGroupUrl() + '/products');

			badge.show(root.find('.buttons .badge'), 'icon-saved', 'saved-text', 5000);
		});
	};

	return {
		init: init,
	};
})(jQuery);

export { productGroupHelper, productGroupList, productGroupDetail };
